import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { EmployeeOnboardingStatusEnum } from "@/core/features/employee-onboarding/employee-onboarding-status.enum";
import { EmployeeOnboardingInvitationDto } from "@/core/features/employee-onboarding/employee-onboarding-invitation.dto";
import { EmployeeOnboardingUploadRequirementDto } from "@/core/features/employee-onboarding/employee-onboarding-upload-requirement.dto";
import { EmployeeOnboardingSignatureRequirementDto } from "@/core/features/employee-onboarding/employee-onboarding-signature-requirement.dto";
import { EmployeeOnboardingAcceptanceDto } from "@/core/features/employee-onboarding/employee-onboarding-acceptance.dto";
import { Transform, Type } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class EmployeeOnboardingProcessDto extends BaseEntityDto {
  userId: string;
  theoreticalPosition?: string | null;
  status: EmployeeOnboardingStatusEnum;
  progressPercent: number;
  formCompleted: boolean;

  @Type(() => UserDto)
  user: UserDto;

  @Transform(({ value }) => parseApiDate(value))
  theoreticalHiredDate?: Date | null;

  @Transform(({ value }) => parseApiDate(value))
  invitationSentAt?: Date | null;

  @Transform(({ value }) => parseApiDate(value))
  firstAccessedAt?: Date | null;

  @Transform(({ value }) => parseApiDate(value))
  submittedAt?: Date | null;

  @Type(() => EmployeeOnboardingInvitationDto)
  invitations?: EmployeeOnboardingInvitationDto[];

  @Type(() => EmployeeOnboardingUploadRequirementDto)
  uploadRequirements?: EmployeeOnboardingUploadRequirementDto[];

  @Type(() => EmployeeOnboardingSignatureRequirementDto)
  signatureRequirements?: EmployeeOnboardingSignatureRequirementDto[];

  @Type(() => EmployeeOnboardingAcceptanceDto)
  acceptances?: EmployeeOnboardingAcceptanceDto[];

  get latestInvitation(): EmployeeOnboardingInvitationDto | null {
    return (
      [...(this.invitations ?? [])].sort(
        (firstInvitation: EmployeeOnboardingInvitationDto, secondInvitation: EmployeeOnboardingInvitationDto) =>
          secondInvitation.createdAt.getTime() - firstInvitation.createdAt.getTime()
      )[0] ?? null
    );
  }
}
